import { FormField, FormItem, FormMessage } from "@patient-watch/ui/form";
import { useId } from "react";
import { useFormContext } from "react-hook-form";
import { ChoiceCard } from "./components/ChoiceCard";
import { ChoiceGroup } from "./components/ChoiceGroup";

interface Props {
    name: string;
    label: string;
    caption?: string;
    description?: string;
    required?: boolean;
    /** Answer labels in the form's language. The stored values stay "yes" and "no". */
    yesLabel?: string;
    noLabel?: string;
}

const YesNo: React.FC<Props> = ({
    name,
    label,
    caption,
    description,
    required = false,
    yesLabel = "Yes",
    noLabel = "No",
}) => {
    const options = [
        { value: "yes", label: yesLabel },
        { value: "no", label: noLabel },
    ];
    const { control } = useFormContext();
    const labelId = `${useId()}-label`;
    const hasQuestionLabel = label.trim().length > 0;

    return (
        <FormField
            control={control}
            name={name}
            render={({ field, fieldState }) => (
                <FormItem>
                    <ChoiceCard
                        labelId={labelId}
                        caption={caption}
                        label={label}
                        required={required}
                        description={description}
                        invalid={fieldState.invalid}
                    >
                        <ChoiceGroup
                            name={name}
                            options={options}
                            value={field.value}
                            onChange={(next) => field.onChange(next)}
                            invalid={fieldState.invalid}
                            labelledBy={hasQuestionLabel ? labelId : undefined}
                            tabEachOption
                            data-testid={`form-options-${name}`}
                        />
                        <FormMessage />
                    </ChoiceCard>
                </FormItem>
            )}
        />
    );
};

export default YesNo;
